import { render, staticRenderFns } from "./best-card.vue?vue&type=template&id=111942c6&scoped=true&"
import script from "./best-card.vue?vue&type=script&lang=js&"
export * from "./best-card.vue?vue&type=script&lang=js&"
import style0 from "./best-card.vue?vue&type=style&index=0&id=111942c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111942c6",
  null
  
)

export default component.exports